import React from 'react';

/**
 * One visit row's univers: a colored dot plus its name.
 *
 * Color never carries it alone. The palette is validated for fill-vs-fill
 * separation between donut slices, not for text-on-fill luminance — its lightest
 * hue sits at 2.8:1, below the text bar — so the dot takes the hue and the label
 * inherits whatever ink the surface already guarantees.
 */
const UniversChip = ({ label, color, className = '' }) => (
  <span className={`inline-flex items-center gap-1 min-w-0 ${className}`} data-testid="univers-chip">
    <span
      className="w-1.5 h-1.5 rounded-full flex-shrink-0"
      data-testid="univers-dot"
      style={{ backgroundColor: color }}
      aria-hidden
    />
    <span className="truncate font-semibold">{label}</span>
  </span>
);

export default UniversChip;
